export default "__VITE_ASSET__a3ca6a0c__"